import { render, staticRenderFns } from "./lecturelist.vue?vue&type=template&id=550cf9f7&scoped=true"
import script from "./lecturelist.vue?vue&type=script&lang=js"
export * from "./lecturelist.vue?vue&type=script&lang=js"
import style0 from "./lecturelist.vue?vue&type=style&index=0&id=550cf9f7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "550cf9f7",
  null
  
)

export default component.exports